// ReviewsVideo.js
export default class ReviewVideo {
  constructor(videoData) {
    this.url = videoData.url;
    this.previewImage = videoData.previewImage || "";
    this.isPlaying = false;
    this.previewGenerated = false;
  }

  // Создание SVG иконки Play
  createPlayIcon() {
    // <svg class="play-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                   <polygon points="10,6 20,12 10,18" fill="white" stroke="white" stroke-width="4"
    //                     stroke-linejoin="round" />
    //                 </svg>

    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("class", "play-icon");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("fill", "none");
    svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");

    const polygon = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "polygon",
    );
    polygon.setAttribute("points", "10,6 20,12 10,18");
    polygon.setAttribute("fill", "white");
    polygon.setAttribute("stroke", "white");
    polygon.setAttribute("stroke-width", "4");
    polygon.setAttribute("stroke-linejoin", "round");

    svg.append(polygon);

    // const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    // circle.setAttribute('cx', '12');
    // circle.setAttribute('cy', '12');
    // circle.setAttribute('r', '10');
    // circle.setAttribute('stroke', 'white');
    // circle.setAttribute('stroke-width', '1.5');

    // const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    // path.setAttribute('d', 'M10 8L16 12L10 16V8Z');
    // path.setAttribute('fill', 'white');

    // svg.appendChild(circle);
    // svg.appendChild(path);

    return svg;
  }

  // Создание SVG иконки Pause
  createPauseIcon() {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("class", "pause-icon");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("fill", "white");
    svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");

    const rect1 = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "rect",
    );
    rect1.setAttribute("x", "6");
    rect1.setAttribute("y", "4");
    rect1.setAttribute("width", "4");
    rect1.setAttribute("height", "16");
    rect1.setAttribute("rx", "1");

    const rect2 = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "rect",
    );
    rect2.setAttribute("x", "14");
    rect2.setAttribute("y", "4");
    rect2.setAttribute("width", "4");
    rect2.setAttribute("height", "16");
    rect2.setAttribute("rx", "1");

    svg.appendChild(rect1);
    svg.appendChild(rect2);

    return svg;
  }

  // Создание превью блока
  createPreview() {
    const preview = document.createElement("div");

    preview.className = "video-preview";

    // IMG PREVIEW
    const img = document.createElement("img");

    img.className = "video-preview__img";

    img.alt = "Video preview";

    if (this.previewImage) {
      img.src = this.previewImage;
    }

    // preview.appendChild(img);

    // overlay
    const overlay = document.createElement("div");

    overlay.className = "video-preview__overlay";

    preview.appendChild(overlay);

    // play button
    const playBtn = document.createElement("button");

    playBtn.className = "video-preview__play-btn";

    playBtn.appendChild(this.createPlayIcon());

    preview.appendChild(playBtn);

    // save ref
    this.previewImg = img;

    return {
      preview,
      playBtn,
    };
  }

  createVideoElement() {
    const video = document.createElement("video");

    video.className = "main-video";

    // video.preload = "metadata";
    video.preload = "auto";

    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");

    video.playsInline = true;

    video.controls = false;

    video.muted = false;

    const sourceMp4 = document.createElement("source");

    sourceMp4.src = this.url;
    sourceMp4.type = "video/mp4";

    video.appendChild(sourceMp4);

    return video;
  }

  // Создание кнопки паузы
  createPauseButton() {
    const pauseBtn = document.createElement("button");
    pauseBtn.className = "pause-btn";
    pauseBtn.appendChild(this.createPauseIcon());
    return pauseBtn;
  }

  // Создание видео контейнера
  createVideoContainer() {
    const container = document.createElement("div");
    container.className = "reviews-video-card";

    const wrapper = document.createElement("div");
    wrapper.className = "video-wrapper";

    const { preview, playBtn } = this.createPreview();
    const video = this.createVideoElement();
    const pauseBtn = this.createPauseButton();

    wrapper.appendChild(preview);
    wrapper.appendChild(video);
    wrapper.appendChild(pauseBtn);
    container.appendChild(wrapper);

    this.elements = {
      preview,
      // previewImg: this.previewImg,
      playBtn,
      video,
      pauseBtn,
      wrapper,
    };

    return container;
  }

  // Показать кнопку паузы
  showPauseButton() {
    if (this.isPlaying) {
      this.elements.pauseBtn.classList.add("visible");
    }
  }

  // Скрыть кнопку паузы
  hidePauseButton() {
    this.elements.pauseBtn.classList.remove("visible");
  }

  // Проверить, находится ли курсор на wrapper
  isMouseOverWrapper() {
    const wrapper = this.elements.wrapper;
    if (!wrapper) return false;

    const rect = wrapper.getBoundingClientRect();
    const x = event?.clientX;
    const y = event?.clientY;

    if (x !== undefined && y !== undefined) {
      return (
        x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom
      );
    }
    return false;
  }

  // Запуск видео
  startVideo() {
    const video = this.elements.video;

    this.elements.preview.classList.add("hidden");

    const promise = video.play();

    if (promise) {
      promise
        .then(() => {
          this.isPlaying = true;

          this.showPauseButton();
        })
        .catch((err) => {
          // console.log("Play error:", err);

          this.elements.preview.classList.remove("hidden");
        });
    }
  }

  // Пауза
  pauseVideo() {
    if (!this.isPlaying) return;

    this.elements.video.pause();
    this.isPlaying = false;

    this.hidePauseButton();
    this.elements.preview.classList.remove("hidden");
    // this.elements.video.style.display = 'none';
  }

  // Инициализация обработчиков событий
  initEventListeners() {
    const { preview, playBtn, video, pauseBtn, wrapper } = this.elements;

    // Запуск видео по клику на превью или кнопку Play
    playBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      this.startVideo();
    });

    preview.addEventListener("click", (e) => {
      e.stopPropagation();
      this.startVideo();
    });

    // Пауза по клику на кнопку паузы
    pauseBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      this.pauseVideo();
    });

    // Пауза/воспроизведение по клику на само видео
    video.addEventListener("click", (e) => {
      e.stopPropagation();
      if (this.isPlaying) {
        this.pauseVideo();
      } else {
        this.startVideo();
      }
    });

    // Показываем кнопку паузы при наведении на wrapper (только если видео играет)
    wrapper.addEventListener("mouseenter", () => {
      if (this.isPlaying) {
        this.showPauseButton();
      }
    });

    // Скрываем кнопку паузы когда курсор уходит с wrapper
    wrapper.addEventListener("mouseleave", () => {
      this.hidePauseButton();
    });

    // Окончание видео
    video.addEventListener("ended", () => {
      this.isPlaying = false;
      // this.elements.video.style.display = "none";
      this.elements.preview.classList.remove("hidden");
      this.hidePauseButton();
      this.elements.video.currentTime = 0;
    });

    // Ошибка загрузки видео
    video.addEventListener("error", (e) => {
      console.error("Ошибка загрузки видео:", this.url, e);
    });
  }

  // Генерация превью из первого кадра видео
  generatePreviewFromVideo() {
    if (this.previewGenerated || this.previewImage) return;

    this.previewGenerated = true;

    const video = document.createElement("video");

    video.src = this.url;
    video.muted = true;
    video.playsInline = true;
    video.preload = "auto";

    // ❗ важно убрать CORS если локальные файлы
    video.crossOrigin = "anonymous";

    const cleanup = () => {
      video.removeAttribute("src");
      video.load();
    };

    const draw = () => {
      const canvas = document.createElement("canvas");

      canvas.width = video.videoWidth || 640;
      canvas.height = video.videoHeight || 360;

      const ctx = canvas.getContext("2d");

      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      const img = canvas.toDataURL("image/jpeg", 0.85);

      if (this.previewImg) {
        this.previewImg.src = img;
      }

      // console.log("✅ preview generated");

      cleanup();
    };

    video.addEventListener("loadedmetadata", () => {
      // 🔥 ключевой момент
      video.currentTime = 0.2;
    });

    video.addEventListener("seeked", () => {
      requestAnimationFrame(draw);
    });

    video.addEventListener("error", (e) => {
      console.error("video error", e);
    });

    video.load();
  }

  // Рендер всего компонента
  render() {
    const container = this.createVideoContainer();

    this.initEventListeners();

    // if (!this.previewImage) {
    //   requestAnimationFrame(() => {
    //     this.generatePreviewFromVideo();
    //   });
    // }

    return container;
  }

  // Получить HTML элемент для вставки в слайдер
  getSlide() {
    const slide = document.createElement("div");
    slide.className = "swiper-slide";
    slide.appendChild(this.render());
    return slide;
  }
}
